// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 3H7V6.5H9V5H10.5V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5 3H12.5V5H15.5V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 3H17.5V5H19V6.5H21V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 19V7.5H3V21H16.5V19H5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 11.5V8.5H7V11.5H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 11.5V8.5H19V11.5H21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 15V13.5H7V17H10.5V15H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 17V13.5H19V15H17.5V17H21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5 15H12.5V17H15.5V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 7H11V13H17V7Z"}}]};

const FlipToBackFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flip-to-back-filled',
    ref,
    icon: element,
  },
));

FlipToBackFilledIcon.displayName = 'FlipToBackFilledIcon';

export default FlipToBackFilledIcon;
